import '@visma-swno/gaia-chat-ui';
import React, {useRef, useEffect} from "react";
import "./ai_assistant.scss";
import { Sparkles } from 'lucide-react';
import {useSelector} from "react-redux";
import * as reduxSelectors from "components/store/application.reducers.js";
import { ICON_SIZE } from "components/common/constants";

const ASSISTANT_LANGUAGES = ['en', 'no', 'sv', 'da'];

export const AiAssistant = () => {
    const [isOpen, setIsOpen] = React.useState(false);
    const assistantRef = useRef(null);
    const userLang = useSelector(reduxSelectors.getLanguage);
    const selectedLanguage = ASSISTANT_LANGUAGES.includes(userLang) ? userLang : 'en';

    useEffect(() => {
        if (!assistantRef.current) return;
        const onClose = () => setIsOpen(false);
        assistantRef.current.addEventListener('close-requested', onClose);
        return () => assistantRef.current?.removeEventListener('close-requested', onClose);
    }, [isOpen]);

    return (
        <li className="icon">
            <a href={"#assistant"} data-testid={"open-assistant"} onClick={() => {
                setIsOpen(!isOpen)
            }}>
                <Sparkles id="chat-trigger" aria-label="AI Assistant" className="ai-assistant-icon" size={ICON_SIZE.MEDIUM}/>
            </a>
            <aside id="popover-wrapper" data-testid={"popover-wrapper"} style={{display: isOpen ? 'block' : 'none'}}
                 aria-label="Assistant">
                {isOpen &&
                    <gaia-chat
                        id="chat-component"
                        ref={assistantRef}
                        data-testid={"chat-component"}
                        profile-id={"approval-prod"}
                        auth-strategy={"visitor"}
                        base-url={window.ENVIRONMENT.AI_ASSISTANT_BASE_URL}
                        closeable={true}
                        lang={selectedLanguage}
                    ></gaia-chat>
                }
            </aside>
        </li>
    )

}

export default AiAssistant;

